<template>
  <ListeReferentiel
    ref="liste"
    titre="Types d'hospitalisation"
    icone="bi-hospital"
    ressource="type_hospitalisations"
    tri-defaut="th.libelle"
    :options-tri="{ Libellé: 'th.libelle', Statut: 'th.isEnabled' }"
    placeholder="Libellé ou description…"
    unite="type(s)"
    vide="Aucun type d'hospitalisation enregistré."
    :colonnes="7"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_TYPE_HOSPITALISATION')"
    libelle-creer="Nouveau type"
    @creer="creation"
  >
    <template #entete>
      <th>Libellé</th>
      <th class="d-none d-md-table-cell">Description</th>
      <th>Statut</th>
      <th class="d-none d-lg-table-cell">Créé le</th>
      <th class="d-none d-lg-table-cell">Modifié le</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: type }">
      <td>{{ type.libelle }}</td>
      <td class="d-none d-md-table-cell">{{ type.description || '—' }}</td>
      <td>
        <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-secondary']">{{ type.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td class="d-none d-lg-table-cell">{{ formatDate(type.createdAt) }}</td>
      <td class="d-none d-lg-table-cell">{{ formatDate(type.updatedAt) }}</td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_TYPE_HOSPITALISATION', 'CONFIG_SUPPRESSION_TYPE_HOSPITALISATION'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_TYPE_HOSPITALISATION')"><a class="dropdown-item" href="#" @click.prevent="modifier(type.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_TYPE_HOSPITALISATION')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(type)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeTypeHospitalisation',
  components: { ListeReferentiel },
  methods: {
    creation() {
      this.$router.push({ name: 'create_type_hospitalisation' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_hospitalisation', params: { id } });
    },
    supprimer(type) {
      this.$refs.liste.supprimer({
        id: type.id,
        titre: "Supprimer le type d'hospitalisation",
        message: `Supprimer le type d'hospitalisation « ${type.libelle} » ?`,
        succes: "Type d'hospitalisation supprimé.",
      });
    },
    formatDate(date) {
      return date ? new Date(date).toLocaleDateString('fr-FR') : '—';
    },
  },
};
</script>
